module.exports = __webpack_public_path__ + "static/media/Login.7bfad00a.PNG";